import { style } from '@vtex/admin-ui'

export const calendar = style({
  zIndex: 9999,
})

export const stack = style({
  marginBottom: '$space-3',
})

export const flex = style({
  paddingX: '$space-5',
  width: '100%',
})

export const dateField = style({
  width: '100%',
  '> div': {
    width: '100%',
  },
})

export const fitWidth = style({
  width: 'fit-content',
})
